import { ActionButton, TooltipHost } from "@fluentui/react";
import React, { FC } from "react";
import { getOrdersClient } from "../lib/api";
import { useAppState } from "../context/AppContext";
import { OrderLineModel } from "../lib/models/OrderLine";
import { useWriteToOrderLines } from "../hooks/useWriteToOrderLines";
import { useLoadLocalOrderLines } from "../hooks/useLoadOrderLies";
import { BcOrderDto } from "../lib/models/BcOrderDto";
import { useAsync } from "../hooks/useAsync";

const createOrderLineFromNew = (o: BcOrderDto) => {
  return new OrderLineModel(
    [
      o.ProjectNo,
      o.DeliveryID,
      +o.LineNo,
      o.ItemNo,
      o.ItemDescription,
      +o.ItemQty,
      o.ItemUOM,
      +o.ItemUnitPrice,
      o.OrderDescription,
      o.Contractstatus,
      o.FerdigMontert,
      o.BizArea,
      o.Orderclassification,
      o.ProductGroup,
      o.ProductType,
      true,
      o.TransferredDT,
      o.TransferredUserID,
      o.OrderNo,
      o.OrderHyperlink || "",
      o.SystemCreatedAt,
      o.StatusCodeERP,
      o.StatusMsgERP,
    ],
    o.LineNo
  );
};

type OrderSyncerProps = {
  onError: (error: string) => void;
};

export const OrderSyncer: FC<OrderSyncerProps> = ({ onError }) => {
  const { state } = useAppState();
  const { execute: fetchOrders, isLoading } = useAsync();
  const { write } = useWriteToOrderLines();
  const { reload } = useLoadLocalOrderLines({ noInitialLoad: true });

  const sync = async () => {
    if (!state.projectNumber) return;
    onError("");

    fetchOrders(
      {
        onComplete: async (orders) => {
          console.log(orders);
          if (state.orderLines.length == 0) {
            await write(orders.map(createOrderLineFromNew));
          } else {
            const newLines = state.orderLines.map((ol) => {
              const newLine = new OrderLineModel(ol.toExcelRow(), ol.originalIndex);
              const line = orders.find(
                (o) => o.LineNo == newLine.lineNo && o.DeliveryID == ol.deliveryId && !ol.orderNo
              );
              if (line) {
                newLine.sentByUser = line?.TransferredUserID || "unknown";
                newLine.orderNo = line.OrderNo || "";
                newLine.orderUrl = line?.OrderHyperlink || "";
                newLine.orderDescription = line?.OrderDescription || "";
                newLine.orderCreatedTime = line?.OrderCreatedDT || "";
                newLine.businessCentralStatusMessage = line?.StatusMsgERP || "";
                newLine.businessCentralStatusCode = line?.StatusCodeERP || "";
              }
              return newLine;
            });

            const o = orders
              // remove lines that already exists
              .filter(
                (ol) =>
                  !newLines.find((o) => o.lineNo == ol.LineNo && o.deliveryId == ol.DeliveryID)
              )
              .map(createOrderLineFromNew);

            newLines.push(...o);

            await write(newLines);
          }

          await reload();
        },
        onError: (data) => {
          onError(data?.message || "");
        },
      },
      () => {
        return getOrdersClient.getOrders(
          new URLSearchParams({ projectNo: state.projectNumber || "" })
        );
      }
    );
    // const orders = await
  };

  return (
    <TooltipHost id="sync-tooltip" content="Henter eksisterende ordrelinjer fra Business Central">
      <ActionButton
        aria-describedby="sync-tooltip"
        disabled={!state.projectNumber || isLoading}
        iconProps={{ iconName: "Sync" }}
        text={isLoading ? "Henter..." : "Hent fra BC"}
        onClick={sync}
      />
    </TooltipHost>
  );
};
